export default __webpack_public_path__ + "static/media/undraw_media_player_re_rdd2.3f6fd59b.svg";